import React, { ReactNode, useContext, useMemo } from 'react';
import { ConfigProvider } from 'antd';
import localePT from 'antd/lib/locale/pt_BR';
import localeEN from 'antd/lib/locale/en_US';
import localeES from 'antd/lib/locale/es_ES';
import KeycloakContext from './Keycloak/KeycloakContext';

const AntdConfigProvider = ({ children }: { children: ReactNode }) => {
  const { keycloak } = useContext(KeycloakContext);
  const locale = keycloak?.idTokenParsed?.locale;

  const handleLocale = useMemo(() => {
    if (locale === 'pt') {
      return localePT;
    }
    if (locale === 'en') {
      return localeEN;
    }
    return localeES;
  }, [locale]);

  return <ConfigProvider locale={handleLocale}>{children}</ConfigProvider>;
};

export default AntdConfigProvider;
